<div style="padding: 20px;" class="error-wrap">
    <img src="assets/svg/Vector.svg" alt="" class="vector">
    <div class="error-text">
        {{message}}
    </div>
    <div class="flex-center" style="width: 50%;">
        <button mat-flat-button class="flat" (click)="closeDialog()">Close</button> &nbsp; &nbsp;
    </div>
</div>
